// extracted by mini-css-extract-plugin
export default {"logo__container":"partnerlogo_logo__container__dbVQz","logo_item":"partnerlogo_logo_item__hcop7","image_logo":"partnerlogo_image_logo__a68xi"};